import { render, staticRenderFns } from "./chartTitle.vue?vue&type=template&id=1db231b4&scoped=true"
var script = {}
import style0 from "./chartTitle.vue?vue&type=style&index=0&id=1db231b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db231b4",
  null
  
)

export default component.exports